<template>
  <div class="main-header">
    <div class="header">
      <h2>
        <i class="el-icon-s-unfold" v-if="menuData.collapse" @click="switchCollapseMenu(null)"></i>
        <i class="el-icon-s-fold" v-else @click="switchCollapseMenu(null)"></i>
        {{title}}
      </h2>
      <div class="user">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <img v-if="sysUserInfo != null" :src="sysUserInfo.avatar == null ? '/static/avatar/man.png' : sysUserInfo.avatar" alt=""><b>{{ JSON.parse(sysUserInfo).userName }}</b><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/index.js'
import { mapState, mapMutations } from 'vuex'
import GlobalWindow from './GlobalWindow'
export default {
  name: 'Header',
  components: { GlobalWindow },
  computed: {
    ...mapState(['menuData', 'sysUserInfo']), // store变量
    title () {
      return this.$route.meta.title
    }
  },
  methods: {
    ...mapMutations(['setSysUserinfo', 'switchCollapseMenu']), // store方法
    // 退出登录
    logout () {
      this.$router.push({name: 'login'})
      // this.setRegisterUserInfo(null)
      store.commit('logout')
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/style/variable";
.header {
  overflow: hidden;
  padding: 0 25px;
  background: #fff;
  height: 100%;
  display: flex;
  h2 {
    width: 50%;
    flex-shrink: 0;
    line-height: @header-height;
    font-size: 19px;
    font-weight: 600;
    color: #606263;
    display: inline;
    & > i {
      font-size: 20px;
      margin-right: 12px;
    }
  }
  .user {
    width: 50%;
    flex-shrink: 0;
    text-align: right;
    .el-dropdown {
      top: 2px;
    }
    img {
      width: 32px;
      position: relative;
      top: 10px;
      margin-right: 10px;
    }
  }
}
// 下拉菜单框
.el-dropdown-menu {
  width: 140px;
  .el-dropdown-menu__item:hover {
    background: #E3EDFB;
    color: @primary-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue